export const contactForm = () => {

    const contactFormArray = [ 
        "main-contact-form",       
        "mobile-contact-form"
    ]

    contactFormArray.forEach(idContactForm => {

        let contactForm = document.querySelector("#" + idContactForm)

        if (contactForm) {

            const checkbox = contactForm.querySelectorAll(".checkbox") 
            const checkboxCustom = contactForm.querySelectorAll(".custom-checkbox")
            
            const inputBox = contactForm.querySelectorAll(".input")
            const allUnderLine = contactForm.querySelectorAll(".contact-form__under-line path")

            const dottedTextName = contactForm.querySelector(".dotted-text-name") 
            const dottedTextContactDetails = contactForm.querySelector(".dotted-text-contact-details")
            const inputName = contactForm.querySelector(".contact-form-name") 
            const inputContactDetails = contactForm.querySelector(".contact-form-contacts")            

            const andText = contactForm.querySelector(".and-text")
            const leftText = contactForm.querySelector(".left-text")

            const submitButton = contactForm.querySelector(".submit-button")
            submitButton.setAttribute("disabled", "")

            const contactsCustomErrorField = contactForm.querySelector(".contacts-custom-error-field")            
            
            //-------------------------------------------------------------------------------------------------------------------------
            // changing an image of a custom checkbox
            //-------------------------------------------------------------------------------------------------------------------------

            function customCheckboxAction(classCustomCheckbox, classCustomLabel, idCommonCheckbox) {
            
                const checkbox = contactForm.querySelector(" ." + classCustomCheckbox)
                const label = contactForm.querySelector(" ." + classCustomLabel) 
                const commonCheckbox = contactForm.querySelector(" ." + idCommonCheckbox)           

                // hovering on a label
                label.onmouseover = () => {
                    if (checkbox.classList.contains("custom-checkbox-checked")) {
                        checkbox.classList.add("active-hover-checked")
                    } else {
                        checkbox.classList.add("active-hover")
                    }            
                }

                // not hovering on a label
                label.onmouseout = () => {
                    checkbox.classList.remove("active-hover")
                    checkbox.classList.remove("active-hover-checked")
                }  

                // clicking on a checkbox
                checkbox.addEventListener("click", () => { 
                      
                    if (checkbox.classList.contains("custom-checkbox-agreement")) {
                        submitButton.classList.toggle("button-inactive")
                        submitButton.toggleAttribute("disabled") 
                        checkbox.classList.toggle("custom-checkbox-checked") 
                        commonCheckbox.toggleAttribute("checked")                   
                    } 
                    else {
                        checkbox.classList.toggle("custom-checkbox-checked") 
                        commonCheckbox.toggleAttribute("checked")
                    }             
                })

                // clicking on a label
                label.addEventListener('click', () => {
                    checkbox.classList.toggle("custom-checkbox-checked")
                    checkbox.classList.toggle("active-hover-checked")
                    checkbox.classList.toggle("active-hover")
                    commonCheckbox.toggleAttribute("checked")
                    if (label.classList.contains("label-checkbox-agreement")) {
                        submitButton.classList.toggle("button-inactive")
                        submitButton.toggleAttribute("disabled")                    
                    }
                })
            
            }

            customCheckboxAction("checkbox-theme1", "label-checkbox-theme1", "checkbox-theme1")
            customCheckboxAction("checkbox-theme2", "label-checkbox-theme2", "checkbox-theme2")
            customCheckboxAction("checkbox-theme3", "label-checkbox-theme3", "checkbox-theme3")

            customCheckboxAction("custom-checkbox-agreement", "label-checkbox-agreement", "checkbox-agreement") 
            
            
            //------------------------------------------------------------------------------------------------------------------------------
                            
            // clicking on an input
            inputBox.forEach(inputItem => {
                inputItem.addEventListener("click", () => { 
                    allUnderLine.forEach(itemUnderLine => {
                        itemUnderLine.style.stroke = "#D9D9D9"
                    })    
                    const underLine = inputItem.querySelector(".contact-form__under-line path")            
                    underLine.style.stroke = "#0077FD"
                })
            })

            // focusing on Name an input
            dottedTextName.addEventListener("click", () => {  
                allUnderLine.forEach(itemUnderLine => {
                    itemUnderLine.style.stroke = "#D9D9D9"
                })       
                inputName.focus()
                const underLine = contactForm.querySelector(".contact-form__name-box .contact-form__under-line path")            
                underLine.style.stroke = "#0077FD"
            })

            // focusing on Contact Details an input
            dottedTextContactDetails.addEventListener("click", () => { 
                allUnderLine.forEach(itemUnderLine => {
                    itemUnderLine.style.stroke = "#D9D9D9"
                })         
                inputContactDetails.focus()
                const underLine = contactForm.querySelector(".contact-form__contacts-box .contact-form__under-line path")            
                underLine.style.stroke = "#0077FD"
            })

            // checking a value of Name and Contact Details an input
            contactForm.addEventListener("input", () => {          

                if ( inputName.value ) {
                    dottedTextName.classList.add("dotted-text-hide")   
                    andText.classList.add("dotted-text-hide")         
                }
                else {
                    dottedTextName.classList.remove("dotted-text-hide") 
                    andText.classList.remove("dotted-text-hide")           
                }  

                if ( inputContactDetails.value ) {
                    dottedTextContactDetails.classList.add("dotted-text-hide")  
                    andText.classList.add("dotted-text-hide")
                    contactsCustomErrorField.classList.remove("contacts-custom-error-field-show")
                }
                else {
                    dottedTextContactDetails.classList.remove("dotted-text-hide")                         
                }       
                
                if ( (inputName.value) && (inputContactDetails.value) ) {
                    leftText.classList.add("dotted-text-hide")
                }
                else {
                    leftText.classList.remove("dotted-text-hide")
                }
            })    

            function mailValidator() {
                const mailFormat = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})|([0-9]{10})+$/        
                if (mailFormat.test(inputContactDetails.value)) {            
                    return true
                }
                else {
                    return false
                }
            }
                
            // doing before Submit a Form
            submitButton.addEventListener("click", (e) => {  

                if (mailValidator() == false ) { 
                    
                    allUnderLine.forEach(itemUnderLine => {
                        itemUnderLine.style.stroke = "#D9D9D9"
                    }) 
                    inputContactDetails.focus()
                    const underLine = contactForm.querySelector(".contact-form__contacts-box .contact-form__under-line path")            
                    underLine.style.stroke = "#0077FD"        

                    
                    contactsCustomErrorField.classList.add("contacts-custom-error-field-show")
                    e.preventDefault()            
                }
                else {
                    contactsCustomErrorField.classList.remove("contacts-custom-error-field-show")                    
                }
                
            })

            function clearAll() {

                // restore texts
                dottedTextName.classList.remove("dotted-text-hide")
                andText.classList.remove("dotted-text-hide")
                dottedTextContactDetails.classList.remove("dotted-text-hide")
                leftText.classList.remove("dotted-text-hide")

                // restore udrelines in inputs
                allUnderLine.forEach(itemUnderLine => {
                    itemUnderLine.style.stroke = "#D9D9D9"
                })  

                // restore checkboxs
                checkbox.forEach(checkboxItem => {
                    checkboxItem.removeAttribute("checked")            
                })    
                
                // restore custome checkboxs
                checkboxCustom.forEach(checkboxCustomItem => {
                    checkboxCustomItem.classList.remove("custom-checkbox-checked")            
                })
                
                // restore a submit button
                submitButton.setAttribute("disabled", "") 
                submitButton.classList.add("button-inactive")

                // restore an email validator
                contactsCustomErrorField.classList.remove("contacts-custom-error-field-show") 
                
            }

            // doing after Send an email
            contactForm.addEventListener("wpcf7mailsent", () => {
                clearAll()   
            }) 

            // close overlay button
            if (idContactForm === "mobile-contact-form") {
                
                const feedbackOverlayCloseButton = document.querySelector(".feedback-overlay__close-button")
                feedbackOverlayCloseButton.addEventListener("click", () => {                     
                    clearAll()  
                    contactForm.reset()         
                })

            }   
        
        }

    })
}   